import {useMutation} from '@tanstack/react-query';
import {OperationStateTypesEnum} from 'presentation/constants/operationStateEnum';
import {postResendPhoneOtpCode} from '../../services/postResendPhoneOtpCode';
import {ResendPhoneOtpMutation} from './types';

export function useResendPhoneOtpMutation({setChangingCellphoneState}: ResendPhoneOtpMutation) {
	return useMutation({
		mutationFn: postResendPhoneOtpCode,
		onMutate: async () => {
			setChangingCellphoneState(OperationStateTypesEnum.PENDING);
		},
		onSettled: () => {
			setChangingCellphoneState(OperationStateTypesEnum.DONE);
		},
	});
}
